import { useNavigate } from "react-router-dom";
import { BadgeCheck, CheckCircle2 } from "lucide-react";

/**
 * Compact, fully-clickable tagged-pro card for Wall posts & comments.
 * Shows ONLY logo/avatar, company name, Verified + Worked Together badges.
 * No category, no QR, no separate view-profile button. Accent = card color.
 */
export const ProMiniCard = ({ pro }) => {
  const navigate = useNavigate();
  if (!pro) return null;
  return (
    <button
      onClick={(e) => { e.stopPropagation(); navigate(`/pro/${pro.user_id}`); }}
      className="mt-1 mb-3 w-full text-left rounded-xl border border-black/10 p-2.5 flex items-center gap-3 hover:brightness-[0.98] transition"
      style={{ background: pro.card_color || "#FFFFFF", borderLeft: `4px solid ${pro.pin_color || "#C79B6B"}` }}
      data-testid={`pro-mini-card-${pro.user_id}`}
    >
      {pro.avatar_url
        ? <img src={pro.avatar_url} className="w-10 h-10 rounded-lg object-cover ring-1 ring-black/10 shrink-0" alt=""/>
        : <div className="w-10 h-10 rounded-lg bg-[#2E6B57] grid place-items-center font-bold shrink-0">{pro.business_name?.[0]}</div>}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold leading-tight truncate" style={{ fontFamily: "Outfit" }}>{pro.business_name}</p>
        <div className="flex items-center gap-2 mt-0.5">
          {pro.verified && <span className="inline-flex items-center gap-0.5 text-[10px] font-bold text-[#245544]"><BadgeCheck size={11}/> Verified</span>}
          {pro.worked_together && <span className="inline-flex items-center gap-0.5 text-[10px] font-bold text-[#245544]"><CheckCircle2 size={11}/> Worked Together</span>}
        </div>
      </div>
    </button>
  );
};

export default ProMiniCard;
